import { disableLoader, enableLoader, showError, showSuccess, showWarning } from '@context/actions';
import ConfirmationModal from '@module/confirmationModal';
import { getAppointmentByTenantIdAndGuestId, requestAppointmentReschedule, rescheduleAppointment } from '@storeData/appointment';
import { addDayToDate, createSlots, formatTimeTo12Hr, formatToDateFormat, getDateObj, getDefaultSlotTime, getDisabledDates, getSystemBusinessDate, minutesToTime, timeToMinutes } from '@util/utils';
import { forwardRef, memo, useEffect, useRef, useState } from 'react';
import { useCookies } from 'react-cookie';
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from 'react-redux';

import {
  CloseIcon,
  FaCalendarAlt,
  IconFrame,
} from '@element/icons';
function SlotRescheduleModal({ item, onClose, setAppointmentHistoryData }) {

    const modalRef = useRef(null);
    const dispatch = useDispatch();
    const appointmentItems = useSelector((state: any) => state.appointmentServices);
    const [selectedItem, setSelectedItem] = useState(item)
    const [error, setError] = useState({ id: '', text: '' });
    const [anchorEl, setAnchorEl] = useState(null);
    const storeData = useSelector((state: any) => state.store ? state.store.storeData : null);
    const [availableExpertSlotData, setAvailableExpertSlotData] = useState([]);
    const [availableSlots, setAvailableSlots] = useState([])
    const { configData } = useSelector((state: any) => state.store ? state.store.storeData : null);
    const APPOINTMENT_SLOT_GAP_IN_MINS = getDefaultSlotTime(configData)
    const [isLoading, setIsLoading] = useState(false);
    const store = useSelector((state: any) => state);
    const appointmentConfig = configData?.storeConfig?.appointmentConfig;
    const [dateChangeConfirmationModal, setDateChangeConfirmationModal] = useState({
        secondaryButtonText: "",
        openModal: false,
        title: '',
        message: '',
        buttonText: '',
        handleClose: null
    })
    const [selectedDate, setSelectedDate] = useState<any>(new Date(item.appointmentDay));
    const [selectedSlot, setSelectedSlot] = useState<any>('');
    const [activeInput, setActiveInput] = useState('');
    const [minDate, setMinDate] = useState(new Date());
    const [cookie, setCookie] = useCookies();
    const [userData, setUserCookie] = useState(cookie['user']);
    const [storeSlot, setStoreSlot] = useState(createSlots(storeData.configData?.dayWiseTiming[(new Date()).getDay()].startTime, storeData.configData?.dayWiseTiming[(new Date()).getDay()].closureTime, APPOINTMENT_SLOT_GAP_IN_MINS));
    const languageData: any = store.languageKeywords

    const DatePickerInput = forwardRef((props: any, ref: any) => <button className={`date-picker-button ${error.id == 'date' ? "error" : ""}`}
        onClick={props.onClick} ref={ref}>
        {languageData["Appointment Date"] ? languageData["Appointment Date"] : "Appointment Date"}: {props.value ? `: ${props.value}` : <div className='guided-label'>{languageData["Click to select date"] ? languageData["Click to select date"] : "Click to select date"}</div>}
    </button>);

    useEffect(() => {
        const browserNow = new Date();
        const businessNow = getSystemBusinessDate(configData?.dayWiseTiming);
        const isToday = getDateObj(businessNow).dateObj === getDateObj(selectedDate).dateObj;
        const selectedDayOfWeek = new Date(getDateObj(selectedDate).dateObj).getDay();
        const timings = configData?.dayWiseTiming[selectedDayOfWeek];
        let slots: string[] = [];
        if (timings && timings.startTime && timings.closureTime) {
            if (isToday) {
                let shiftStart = timeToMinutes(timings.startTime);
                let shiftEnd = timeToMinutes(timings.closureTime);
                if (shiftEnd <= shiftStart) shiftEnd += 1440;
                let currentMins = (browserNow.getHours() * 60) + browserNow.getMinutes();
                if (shiftEnd > 1440 && currentMins < (shiftEnd % 1440)) {
                    currentMins += 1440;
                }
                const interval = APPOINTMENT_SLOT_GAP_IN_MINS || 30;
                const remainder = currentMins % interval;
                const bookingStartMins = currentMins + (interval - remainder);

                if (bookingStartMins >= shiftEnd) {
                    slots = [];
                } else {
                    const startTimeString = minutesToTime(bookingStartMins % 1440);
                    slots = createSlots(startTimeString, timings.closureTime, interval);
                }
            } else {
                slots = createSlots(timings.startTime, timings.closureTime, APPOINTMENT_SLOT_GAP_IN_MINS);
            }
        }
        if (slots.length > 0) slots.pop();

        if (!slots || slots.length === 0) {
            const nextBusinessDay = addDayToDate(businessNow, 1);
            setMinDate(nextBusinessDay);
            setSelectedDate(addDayToDate(new Date(selectedDate), 1));
        } else {
            setStoreSlot(slots);
        }
    }, [selectedDate, configData]);

    const onOutsideClick = (event: any) => {
        if (modalRef.current && !modalRef.current.contains(event.target) && !dateChangeConfirmationModal.openModal) {
            onClose();
        }
    }

    const onSelectDate = (date) => {
        setSelectedDate(date);
    }
    const onSelectSlot = (slot) => {
        setActiveInput('');
        setSelectedSlot(slot);
    }

    const onReschedule = () => {

        if (selectedSlot == '') {
            dispatch(showWarning(`${languageData["Please Select Slot"] ? languageData["Please Select Slot"] : "Please Select Slot"}`))
            return;
        }
        onClose()
        dispatch(enableLoader())
        let currDateObj = item.appointmentDay.split("T")[0]
        let selectedDateObj = selectedDate.toISOString().split("T")[0]
        const requestRescheduleBody = {
            "appId": item.id,
            "currDate": currDateObj,
            "requestedDate": selectedDateObj,
            "currTime": item.appointmentTime,
            "requestedTime": selectedSlot,
            "source": "catalog",
            "status": "PENDING",
            "createdOn": new Date()
        }
        const rescheduleBody = {
            "appId": item.id,
            "updateAllRecurring": false,
            "date": selectedDateObj,
            "time": selectedSlot,
            "staffId": null,
            "sendSms": true,
            "requestId": null,
            "source": "catalog"
        }
        if (!appointmentConfig.autoConfirmed) {
            requestAppointmentReschedule(requestRescheduleBody)
                .then((response: any) => {
                    if (response) {
                        dispatch(disableLoader());
                        dispatch(showSuccess(`${languageData["Appointment Reschedule Requested"] ? languageData["Appointment Reschedule Requested"] : "Appointment Reschedule Requested"}`))
                        getAppointmentByTenantIdAndGuestId(userData?.id, userData?.tenantId)
                            .then((appointment: any) => {
                                if (appointment.length) {
                                    appointment.sort(function (a: any, b: any) {
                                        var dateA: any = new Date(a.appointmentDay).getTime();
                                        var dateB: any = new Date(b.appointmentDay).getTime();
                                        return dateA < dateB ? 1 : -1;
                                    });
                                    setAppointmentHistoryData(appointment);
                                    dispatch(disableLoader());
                                }
                            })
                            .catch((e) => {
                                dispatch(disableLoader());
                                dispatch(showError(e.error));
                            })
                    }
                })
                .catch((e) => {
                    dispatch(disableLoader());
                    dispatch(showError(e.error));
                })
        }
        else {
            requestRescheduleBody.status = "CONFIRMED"
            rescheduleAppointment(rescheduleBody)
                .then((response: any) => {
                    if (response) {
                        if (response.code == 200) {
                            requestAppointmentReschedule(requestRescheduleBody)
                                .then((response: any) => {
                                    if (response) {
                                        dispatch(disableLoader());
                                        dispatch(showSuccess(`${languageData["Appointment Rescheduled Successfully"] ? languageData["Appointment Rescheduled Successfully"] : "Appointment Rescheduled Successfully"}`))
                                        getAppointmentByTenantIdAndGuestId(userData?.id, userData?.tenantId)
                                            .then((appointment: any) => {
                                                if (appointment.length) {
                                                    appointment.sort(function (a: any, b: any) {
                                                        var dateA: any = new Date(a.appointmentDay).getTime();
                                                        var dateB: any = new Date(b.appointmentDay).getTime();
                                                        return dateA < dateB ? 1 : -1;
                                                    });
                                                    setAppointmentHistoryData(appointment);
                                                    dispatch(disableLoader());
                                                }
                                            })
                                            .catch((e) => {
                                                dispatch(disableLoader());
                                                dispatch(showError(e.error));
                                            })
                                    }
                                })
                                .catch((e) => {
                                    dispatch(disableLoader());
                                    dispatch(showError(e.error));
                                })
                        }
                    }
                }).catch((e) => {
                    dispatch(disableLoader());
                    dispatch(showError(e.error));
                })
        }

    }
    return (
        <div className='services-cart-modal-wrap backdrop-modal-wrapper'
            onClick={onOutsideClick}
            style={{
                height: 'calc(100vh - calc(100vh - 100%))',
                overflow: 'unset',
                maxHeight: 'calc(100vh - calc(100vh - 100%))',
                backgroundColor: '#131212b3'
            }}>
            <div className='main-wrapper appointment-wrap app-cal-wrapper' ref={modalRef}>
                <div className='heading'> {languageData["Select Reschedule Timing"] ? languageData["Select Reschedule Timing"] : "Select Reschedule Timing"}</div>
                <div className='sub-heading'>
                    {item.invoiceId != "" && <span>{item.invoiceId}</span>}
                    <div>
                        <span className="right-align order-type color">
                            {formatToDateFormat(item.appointmentDay, configData.dateFormat)} {formatTimeTo12Hr(item.appointmentTime)}
                        </span>
                    </div>
                </div>
                <div className="modal-close" onClick={onClose}>
                    <IconFrame width={20} height={20}><CloseIcon /></IconFrame>
                </div>
                <div className='services-list-wrap'>
                    <div className="date-wrap">
                        <div className="date-picker-wrap card app-date-wrap">
                            <DatePicker
                                excludeDates={getDisabledDates(configData)}
                                selected={selectedDate ? new Date(selectedDate) : null}
                                onChange={(date) => onSelectDate(date)}
                                dateFormat="MMMM d"
                                inline
                                minDate={minDate}
                            />
                        </div>
                    </div>

                    <div className="slot-time-outer time-wrap card">
                        <div className="sub-heading heading-index">{languageData["Preferred Time"] ? languageData["Preferred Time"] : "Preferred Time"}</div>
                        {configData && storeSlot.map((storeSlot) => {
                            return <div key={Math.random()} onClick={() => onSelectSlot(storeSlot)} className={selectedSlot == storeSlot ? 'slot-wrap active' : "slot-wrap"}>{formatTimeTo12Hr(storeSlot)}</div>

                        })}
                    </div>
                </div>
                {Boolean(error.text) && <div className='error'>{error.text}</div>}
                <div className="slot-btn-wrap app-slot-align">
                    <button style={{ width: "100%" }} className="primary-btn rounded-btn" onClick={onClose}>{languageData["Cancel"] ? languageData["Cancel"] : "Cancel"}</button>

                    <button style={{ width: "100%" }} className="primary-btn rounded-btn" onClick={onReschedule}>{languageData["Confirm"] ? languageData["Confirm"] : "Confirm"}</button>
                </div>
            </div>
            <ConfirmationModal {...dateChangeConfirmationModal} />
        </div>
    )
}

export default memo(SlotRescheduleModal)

function setMinDate(arg0: any) {
    throw new Error('Function not implemented.');
}
